<template>
  <div class="container" style="justify-content: center">
    <form role="form" name="myForm" @submit.prevent="login">
      <div class="box" style="margin-top: 150px">
        <header class="head">
          <div align="center">
            <img style="margin-top: -80px" src="../../assets/imgs/logo.png" />
          </div>
          <h1>Authentication</h1>
        </header>
        <div
          v-if="successMessage != ''"
          class="alert alert-success text-center"
        >
          <strong>{{ successMessage }}</strong>
        </div>
        <input
          type="text"
          class="username"
          :class="{
            'input-validation-error':
              UsernameFlags.invalid && !UsernameFlags.pristine,
          }"
          name="Username"
          placeholder="Username"
          style="margin-left: 30px"
          v-model="userName"
          v-validate="'required'"
          autocomplete="off"
          autofocus
        />
        <input
          type="password"
          class="password"
          :class="{
            'input-validation-error':
              PasswordFlags.invalid && !PasswordFlags.pristine,
          }"
          name="Password"
          placeholder="Password"
          style="margin-left: 30px"
          v-model="password"
          v-validate="'required'"
        />
        <div>
          <div
            v-bind:id="'g_recaptcha'"
            class="g-recaptcha"
            style="align-items: center"
          ></div>
        </div>
        <span
          class="text-danger"
          style="margin-left: 30px"
          v-if="errors.first('CAPTCHA')"
          >{{ errors.first("CAPTCHA") }}</span
        >
        <div class="row">
          <div class="col-md-6" style="margin-left: 30px">
            <input type="submit" class="login-button" value="login" />
            <!--	<input type="button" class="reset"  value="reset" /> -->
            <loading v-if="loading"></loading>
          </div>
          <div
            class="col-md-6"
            style="float: right; margin-right: -65px; margin-top: 32px"
          >
            <router-link to="ForgotPassword">Forgot Password</router-link>
          </div>
        </div>
        <br />
        <div v-if="message != ''" class="alert alert-danger text-center">
          <strong>{{ message }}</strong>
        </div>
      </div>
    </form>
    <center>
      Powered By
      <a href="https://www.fajr.com.bh/" target="_blank">
        <img
          src="../../assets/imgs/png/FAJRLOGO01.png"
          style="margin-top: 10px; width: 70px; height: 35px"
        />
      </a>
    </center>
  </div>
</template>

<style>
.g-recaptcha {
  display: inline-block;
  align-content: center;
  padding-left: 18%;
  margin-bottom: 15px;
}
</style>
<script>
import * as ACTIONS from "../../store/actions";
import { mapGetters, mapState } from "vuex";
import { mapFields } from "vee-validate";

var CryptoJS = require("crypto-js");

export default {
  data() {
    return {
      userName: "",
      password: "",
      message: "",
      //loading:true,
      successMessage: "",
    };
  },
  methods: {
    login() {
      var vm = this;
      this.message = "";
      this.successMessage = "";
      this.$validator.errors.remove("CAPTCHA");
      var response = grecaptcha.getResponse();
      if (response == null || response == "") {
        this.$validator.errors.add({
          field: "CAPTCHA",
          msg: "Please verify captcha",
        });
        this.$validator.validateAll().then((res) => {
          if (res) {
          } else {
            this.message = "Invalid username or password";
          }
        });
        return;
      }
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store
            .dispatch(ACTIONS.LOGIN_REQUEST, {
              Username: this.userName,
              Password: this.password,
              Captcha: response,
            })
            .then((res) => {
              var vm = this;
              var { data } = res;
              var redirect = "";
              debugger;
              if (data && data.StatusCode == 200) {
                var token = data.ResponseData.token;
                this.SaveKey();
                if (vm.$route.query.redirect) {
                  var res = vm.$route.query.redirect.charAt(0);
                  if (res == "/") {
                    redirect = vm.$route.query.redirect;
                  } else {
                    redirect = "/" + vm.$route.query.redirect;
                  }
                } else {
                  redirect = "/";
                }
                vm.$router.push(redirect);
              } else if (data && data.StatusCode == 211) {
                var token = data.ResponseData.token;
                this.$router.push(
                  "/ChangePassword/" + data.ResponseData.token + redirect
                );
              } else if (
                data &&
                (data.StatusCode == 1 || data.StatusCode == 500)
              ) {
                vm.message = data.StatusMessage;
              } else {
                vm.message = "Invalid Username and Password";
              }
            })
            .catch((err) => {
              console.log(err);
              if (err.response) {
                vm.message =
                  "Request Failed with error: " + err.response.status;
              } else if (!err.status) {
                vm.message = "Network Error Please Check internet connection";
              } else if (err.request) {
                vm.message =
                  "The request was made but no response was received";
              } else {
                vm.message =
                  "something went wrong please contact administrator";
              }
            });
        } else {
          this.message = "Invalid username or password";
        }
      });
    },
    Logout() {
      this.$store.dispatch(ACTIONS.LOAD_REQUEST);
      var vm = this;
      this.$store
        .dispatch(ACTIONS.LOGOUT_REQUEST)
        .then((res) => {
          // vm.$router.push("/login");
        })
        .catch((err) => {
          // vm.$router.push("/login");
        });
    },
    SaveKey() {
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      var key = "univ_id=";
      var clientId = "client_id=";
      var accessToken = "uid="
      var saltToken = "";
      if (ca) {
        var exist = false;
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          if (ca[i]) {
            c = c.toString().trim();
            if (c.indexOf(clientId) == 0) {
              clientId = c.substring(clientId.length, c.length);
            }
            if (c.indexOf(key) == 0) {
              key = c.substring(key.length, c.length);
            }
            if (c.indexOf(accessToken) == 0) {
              saltToken = c.substring(accessToken.length, c.length);
              accessToken = CryptoJS.AES.decrypt(saltToken, key).toString(CryptoJS.enc.Utf8);
            }
          }
        }
      }

      var data = {
        ClientId: clientId,
        UKey: key,
        UToken: accessToken,
        SaltToken: saltToken
      };

      this.$store.dispatch(ACTIONS.LOGIN_TOKEN_SAVE, data);
      var res = document.cookie;
      var multiple = res.split(";");
      for (var i = 0; i < multiple.length; i++) {
        var key = multiple[i].split("=");
        if (key[0].trim() == "univ_id" || key[0].trim() == "client_id") {
          document.cookie = key[0] + " =; expires = Thu, 01 Jan 1970 00:00:00 UTC";
        }
      }
    }
  },
  mounted() {
    var key = this.SiteKey;
    var d = document.getElementById("g_recaptcha");
    grecaptcha.render("g_recaptcha", {
      sitekey: key,
    });
    this.Logout();
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      TOKEN: "TOKEN",
      SiteKey: "GetSiteKey",
    }),
    ...mapFields({
      UsernameFlags: "Username",
      PasswordFlags: "Password",
    }),
  },
};
</script>
